"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.braintreeCreatePaymentRequestGoogle = void 0;
const utils_1 = require("../../utils");
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
const src_1 = require("../..");
function braintreeCreatePaymentRequestGoogle() {
    const googlePayInstance = (0, src_1.getBraintreeGooglePayInstanceChecked)();
    const { merchant_account: merchantAccount, tokenization_key: authorization } = (0, src_1.getBraintreeGoogleCredentialsChecked)();
    const { country_info: countryInfo } = (0, checkout_frontend_library_1.getOrderInitialData)();
    const { iso_code: currencyCode } = (0, checkout_frontend_library_1.getCurrency)();
    const { order_total } = (0, checkout_frontend_library_1.getApplicationState)();
    const { general_settings: { checkout_process: { phone_number_required: phoneNumberRequired } } } = (0, checkout_frontend_library_1.getOrderInitialData)();
    const allowedShippingCountries = countryInfo.filter(c => c.valid_for_shipping);
    const allowedCountryCodes = allowedShippingCountries.map(c => c.iso_code.toUpperCase());
    const paymentDataRequest = googlePayInstance.createPaymentDataRequest({
        transactionInfo: {
            currencyCode: currencyCode,
            totalPrice: (0, utils_1.getValueByCurrency)(order_total, currencyCode),
            totalPriceStatus: 'ESTIMATED'
        }
    });
    paymentDataRequest.callbackIntents = ['SHIPPING_ADDRESS', 'SHIPPING_OPTION', 'PAYMENT_AUTHORIZATION'];
    paymentDataRequest.emailRequired = true;
    paymentDataRequest.shippingAddressRequired = true;
    paymentDataRequest.shippingAddressParameters = { allowedCountryCodes, phoneNumberRequired };
    paymentDataRequest.shippingOptionRequired = true;
    paymentDataRequest.shippingOptionParameters = (0, src_1.getBraintreeShippingOptionsGoogle)();
    const cardPaymentMethod = paymentDataRequest.allowedPaymentMethods[0];
    cardPaymentMethod.parameters.billingAddressRequired = true;
    cardPaymentMethod.parameters.billingAddressParameters = { format: 'FULL', phoneNumberRequired };
    cardPaymentMethod.parameters.allowedCardNetworks = ['AMEX', 'DISCOVER', 'INTERAC', 'JCB', 'MASTERCARD', 'VISA'];
    const tokenizationSpecificParameter = cardPaymentMethod.tokenizationSpecification.parameters;
    tokenizationSpecificParameter['gatewayMerchantId'] = merchantAccount;
    tokenizationSpecificParameter['braintree:clientKey'] = authorization;
    return paymentDataRequest;
}
exports.braintreeCreatePaymentRequestGoogle = braintreeCreatePaymentRequestGoogle;
